export const API_HOST = window.location.host;
export const GENERIC_ERROR_MESSAGE = 'Error. Something went wrong. We were unable to complete your last action... please try again.';
export const PROFILE_API_URL = '/api/profile';
export const PROFILE_RESUME_JSO_API_URL = '/api/profile/resume-jso';
export const FETCH_FAIL_ERROR_MESSAGE = 'We were unable to contact our servers. Please try again.';
